import { ReactNode, useCallback, useState } from "react";
import {
  LastAddedItem,
  MarketBasketFeedbackContext,
} from "./useMarketBasketFeedback";
import type { ConsolidatedBasketOpenSource } from "./consolidatedOrderingTracking";

export const MarketBasketFeedbackProvider = ({
  children,
  onViewBasket,
}: {
  children: ReactNode;
  onViewBasket: (source: ConsolidatedBasketOpenSource) => void;
}) => {
  const [lastAddedItem, setLastAddedItem] = useState<LastAddedItem>();
  const [flyoverVisible, setFlyoverVisible] = useState(false);

  const showFlyover = useCallback((item: NonNullable<LastAddedItem>) => {
    setLastAddedItem(item);
    setFlyoverVisible(true);
  }, []);

  const hideFlyover = useCallback(() => {
    setFlyoverVisible(false);
  }, []);
  const viewBasket = useCallback(() => {
    onViewBasket("toast");
  }, [onViewBasket]);

  return (
    <MarketBasketFeedbackContext.Provider
      value={{
        lastAddedItem,
        flyoverVisible,
        showFlyover,
        hideFlyover,
        viewBasket,
      }}
    >
      {children}
    </MarketBasketFeedbackContext.Provider>
  );
};
